module.exports = __webpack_public_path__ + "static/media/doc.58763de4.svg";